export function convertToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export function base64ToFile(base64: string, fileName: string): File {
  const byteCharacters = atob(base64);
  const byteNumbers = Array.from(byteCharacters).map((c) => c.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);

  const extension = fileName.split('.').pop()?.toLowerCase();
  
  const mime =
    extension === 'pdf' ? 'application/pdf' :
    extension === 'doc' || extension === 'docx' ? 'application/msword' :
    extension === 'xls' || extension === 'xlsx' ? 'application/vnd.ms-excel' :
    extension === 'ppt' || extension === 'pptx' ? 'application/vnd.ms-powerpoint' :
    extension === 'png' ? 'image/png' :
    extension === 'jpg' || extension === 'jpeg' ? 'image/jpeg' :
    'application/octet-stream';

  return new File([byteArray], fileName, { type: mime });
}

export const mesesTramesa = [
    { valor: 1, mes: '1' },
    { valor: 2, mes: '2' },
    { valor: 3, mes: '3' },
    { valor: 4, mes: '4' },
    { valor: 5, mes: '5' },
    { valor: 6, mes: '6' },
    { valor: 7, mes: '7' },
    { valor: 8, mes: '8' },
    { valor: 9, mes: '9' },
    { valor: 10, mes: '10' },
    { valor: 11, mes: '11' },
    { valor: 12, mes: '12' }
  ];

  export const periocoidad = [
    { valor: 3, mes: 'TRI' },
    { valor: 1, mes: 'ME' },
    { valor: 12, mes: 'AN' },
    { valor: 6, mes: 'SE' },
    { valor: 0, mes: 'SP' }
  ];


